
<status-wrapper *ngIf="displayType === displayTypes.narrowPod && exhibitors[fromStandsId] as exhibitor" 
  [status]="exhibitor.confirmed ? 'Confirmed' : 'Not Confirmed'"
  [logoUrl]="exhibitor.logoUrl"
  [readOnly]="readOnly"
  [threeDotOptions]="threeDotOptions"
  [statusOptions]="['Confirmed', 'Not Confirmed']"
  (threeDotSelection)="dotMenuSelection($event, exhibitor)"
  (changeStatus)="changeStatus(exhibitor, $event)">
  <div class="titles">
    <div class="boldContent" [ngClass]="{unnamed: !exhibitor.name}">{{ exhibitor.name || 'Unnamed exhibitor' }}</div>
    <!-- <div *ngIf="!!exhibitor.standNumber">{{ exhibitor.standNumber }}</div> -->
  </div>
</status-wrapper>
<status-wrapper *ngIf="displayType === displayTypes.widePod && exhibitors[fromStandsId] as exhibitor"
  [status]="exhibitor.confirmed ? 'Confirmed' : 'Not Confirmed'" 
  [ngClass]="{ clickable: !readOnly }"
  (click)="readOnly ? null : manageExhibitor(exhibitor)"
  [wideFormat]="true"
  [logoUrl]="exhibitor.logoUrl"
  [readOnly]="readOnly"
  [threeDotOptions]="threeDotOptions"
  [statusOptions]="['Confirmed', 'Not Confirmed']"
  (threeDotSelection)="dotMenuSelection($event, exhibitor)"
  (changeStatus)="changeStatus(exhibitor, $event)">
  <div class="titles wideContent">
    <div class="boldContent" [ngClass]="{unnamed: !exhibitor.name}">{{ exhibitor.name || 'Unnamed exhibitor' }}</div>
    <!-- <div *ngIf="!!exhibitor.standNumber">{{ exhibitor.standNumber }}</div> -->
  </div>
</status-wrapper>


<add-manage-wrapper *ngIf="false && displayType === displayTypes.narrowPod" [titleIcon]="'EXHIBITORS_18'" [hideHRule]="true" [wrapperTitle]="'Exhibitors'" [openLabel]="null">
  <ng-container>
    <div class="empty-text" *ngIf="noExhibitors">{{ emptyText }}</div> <!-- This is not completely correct -->
    <ng-container *ngFor="let exhibitor of exhibitorIds | idsToItems:exhibitors; trackBy: trackById">
      <status-wrapper 
        [status]="exhibitor.confirmed ? 'Confirmed' : 'Not Confirmed'"
        [logoUrl]="exhibitor.logoUrl"
        [readOnly]="readOnly"
        [threeDotOptions]="threeDotOptions"
        [statusOptions]="['Confirmed', 'Not Confirmed']"
        (threeDotSelection)="dotMenuSelection($event, exhibitor)"
        (changeStatus)="changeStatus(exhibitor, $event)">
        <div class="titles">
          <div class="boldContent" [ngClass]="{unnamed: !exhibitor.name}">{{ exhibitor.name || 'Unnamed exhibitor' }}</div>
        </div>
        
      </status-wrapper>
    </ng-container>
  </ng-container>
</add-manage-wrapper>
<add-manage-wrapper *ngIf="false && displayType === displayTypes.widePod" 
  class="performer-list wide"
  titleIcon="EXHIBITORS_18" 
  [hideHRule]="true"  
  wrapperTitle="Exhibitors" 
  [openLabel]="null" 
>
  <div class="empty-text" *ngIf="noExhibitors">{{ emptyText }}</div> <!-- This is not completely correct -->
  <ng-container *ngFor="let exhibitor of exhibitorIds | idsToItems:exhibitors; trackBy: trackById">
    <div class="drag-wrapper" cdkDrag>
      <icon class="handle" matIcon="drag_indicator" cdkDragHandle></icon>
      <status-wrapper
        [status]="exhibitor.confirmed ? 'Confirmed' : 'Not Confirmed'" 
        [ngClass]="{ clickable: !readOnly }"
        (click)="readOnly ? null : manageExhibitor(exhibitor)"
        [wideFormat]="true"
        [logoUrl]="exhibitor.logoUrl"
        [readOnly]="readOnly"
        [threeDotOptions]="threeDotOptions"
        [statusOptions]="['Confirmed', 'Not Confirmed']"
        (threeDotSelection)="dotMenuSelection($event, exhibitor)"
        (changeStatus)="changeStatus(exhibitor, $event)">
        <div class="titles wideContent">
          <div class="boldContent" [ngClass]="{unnamed: !exhibitor.name}">{{ exhibitor.name || 'Unnamed exhibitor' }}</div>
        </div>
      </status-wrapper>
    </div>
  </ng-container>
</add-manage-wrapper>
<ng-container *ngIf="displayType === displayTypes.staticCard">
  <ng-container *ngFor="let exhibitorId of staticExhibitorIds">
    <div *ngIf="exhibitors[exhibitorId] as exhibitor">{{ exhibitor.name }}</div>
  </ng-container>
</ng-container>

<div class="read-only-holder" *ngIf="displayType === displayTypes.readOnly && !noExhibitors">
  <h5>EXHIBITORS</h5>
  <ng-container *ngFor="let exhibitor of exhibitorIds | idsToItems:exhibitors; trackBy: trackById">
    <sponsor-card class="read-only-card" [sponsor]="exhibitor" [bold]="true"></sponsor-card> <!-- Probably need to create an exhibitor card, but leaving for now -->
  </ng-container>
</div>